<template lang="html">
  <div id="StateListContainer" v-if="hasSomethingToShow">
    <div id="reservationTypeIcon" class="inlineBlock" v-if="reservationType !== '通常'" >
      {{ reservationType }}
    </div>
    <div id="confirmTestIcon" class="inlineBlock" v-if="hasConfTest">
      配布物
    </div>
    <div id="hasMessage" class="inlineBlock" v-if="hasMessage()">
      連絡有り
    </div>
  </div>
</template>

<script>
export default {
  props: [
    'reservation'
  ],
  computed: {
    reservationType () {
      return this.reservation.reservation_type
    },
    hasConfTest () {
      return this.reservation.has_test
    },
    hasSomethingToShow () {
      return this.reservationType !== '通常' ||
        this.hasConfTest ||
        this.hasMessage()
    }
  },
  methods: {
    hasMessage () {
      if (this.reservation.message.trim() !== '') {
        return true
      }
      return false
    }
  }
}

</script>

<style lang="css" scoped>
#StateListContainer {
  height: 12px;
  width: 100%;
  display: table;
  table-layout: fixed;
}
.inlineBlock {
  display: table-cell;
  box-sizing: border-box;
  font-size: 1vh;
}
#confirmTestIcon {
  background-color: #ffbbbb; /* 配布物有りの背景色を設定 */
}

#hasMessage {
  background-color: #bbffbb; /* 連絡有りの背景色を設定 */
}
</style>



// WEBPACK FOOTER //
// ReservationStates.vue?4cc007be